import { useMemo, type ReactNode } from 'react';
import { localeTag, translate } from './i18n';
import { I18nContext } from './i18n-store';
import type { Locale } from './types';

export function I18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  const value = useMemo(
    () => ({ locale, localeTag: localeTag(locale), t: translate(locale) }),
    [locale],
  );
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
